import { render } from "./Vehicles.vue?vue&type=template&id=2303ff98"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=2303ff98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__